$(document).ready(function() {
	$('.js-square-image-modal').on('click', function() {
		$('.js-modal-square-image').css('top', ($(window).scrollTop()) + "px");
		$('.js-modal-square-image-img').find('img').attr('src', $(this).find('img').attr('src'));
		$('.js-modal-square-image').show();
	});
	$('.js-modal-square-image').on('click', function(e) {
		if (!((e.target).closest('.b-modal-square__inner'))) {
			$('.js-modal-square-image').hide();
		}
	});
	$('.js-modal-square-image-close').on('click', function() {
		$('.js-modal-square-image').hide();
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/game-loto/modal-square-image.js